import MuiCard, { CardProps } from "@mui/material/Card";

const Card: React.FC<CardProps> = MuiCard;

export default Card;
export type { CardProps };
